import { NavService } from '../../services/nav.service';

export function basicLoader(navService: NavService) {
    return () => {
        //console.log('basic loader');
        // return Promise.reject().catch(() => console.log('loader failed'));
        // return Promise.resolve().then(() => console.log('loader success'));
        return new Promise<void>((resolve) => {
            setTimeout(() => {
                //console.log('delayed init');
                navService.clearLocalStorage();
                navService.authenticateUserRoute();
                resolve();
            }, 100);
        });
    };
}

// export function appUserLoaderLoader(appLoader: AppUserLoaderService) {
//     return () => appLoader.init();
// }
